import { patch } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { z } from "zod";

const relationshipSchema = z.object({
  worker: z.object({
    data: z.object({
      type: z.literal("worker"),
      id: z.string(),
    }),
  }),
});

const markBadgeAsViewedResponseSchema = z.object({
  data: z.object({
    type: z.literal("workerBadge"),
    id: z.string(),
    attributes: z.object({
      viewedAt: z.date(),
    }),
  }),
  relationships: relationshipSchema,
});

export type MarkBadgeAsViewedResponse = z.infer<typeof markBadgeAsViewedResponseSchema>;

export const MARK_BADGE_AS_VIEWED_PATH = "/workers/:workerId/badges/:badgeId";

interface MarkBadgeAsViewedParams {
  workerId: string;
  badgeId: string;
}

export function useMarkBadgeAsViewed(
  options: UseMutationOptions<MarkBadgeAsViewedResponse, unknown, MarkBadgeAsViewedParams> = {}
): UseMutationResult<MarkBadgeAsViewedResponse, unknown, MarkBadgeAsViewedParams> {
  return useMutation({
    mutationFn: async ({ workerId, badgeId }: MarkBadgeAsViewedParams) => {
      const response = await patch<{ viewedAt: Date }, MarkBadgeAsViewedResponse>({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}${MARK_BADGE_AS_VIEWED_PATH.replace(
          ":workerId",
          workerId
        ).replace(":badgeId", badgeId)}`,
        data: { viewedAt: new Date() },
        responseSchema: markBadgeAsViewedResponseSchema,
      });

      return response.data;
    },
    ...options,
  });
}
